import type { NextPage } from 'next';
import router from 'next/router';

import { B2BOrgLayout } from '@/views/Auth/components';
import { withOrgInfo, withSeo } from '@/views/Auth/hocs';
import routes from '@/views/Auth/routes';
import type { B2BOrgProps } from '@/views/Auth/types';
import { getServerSideI18nProps } from '@/views/Auth/utils';

import { RecoverForm } from './components';
import translations from './i18n';

const B2BOrgRecover: NextPage<B2BOrgProps> = ({ orgInfo }) => {
  const { slug } = router.query as { slug: string };
  return (
    <B2BOrgLayout orgInfo={orgInfo}>
      <RecoverForm
        orgInfo={orgInfo}
        onBack={() => window.location.replace(routes.b2bOrgLoginPath(slug))}
      />
    </B2BOrgLayout>
  );
};

export const getServerSideProps = getServerSideI18nProps({
  pageKey: 'b2b-org-recover',
  translations,
});

export default withSeo(withOrgInfo(B2BOrgRecover));
